var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 164.168,
    height: 149.071,
    viewBox: "0 0 164.168 149.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H49V102H0z"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-8{fill:none}.cls-5{fill:#dff6fd}.cls-6{fill:#7acdde}.cls-7{fill:#548aff}.cls-8{stroke:#053462;stroke-linecap:round;stroke-width:5px;stroke-linejoin:round}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2341",
    transform: "translate(-897.905 -188.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2340",
    transform: "translate(860.405 213.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_47",
    fill: "#d8ec84",
    d: "M444.419 418.775a5.479 5.479 0 0 0-2.685.7 7.981 7.981 0 0 0-5.549-5.206v13.54h12.454a5.5 5.5 0 0 0-4.219-9.034z",
    transform: "translate(-265.67 -307.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_48",
    fill: "#cbe558",
    d: "M455.575 137.3a14.559 14.559 0 0 0-19.391-20.412v48.6a14.482 14.482 0 0 0 7-1.944 14.559 14.559 0 1 0 12.391-26.244z",
    transform: "translate(-265.136 -68.612)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_75",
    fill: "#053462",
    d: "M450.466 159.981a16.339 16.339 0 0 0 7.577-30.815 16.353 16.353 0 0 0-21.858-21.579v4.077a12.783 12.783 0 0 1 17.877 17.408 1.78 1.78 0 0 0 .889 2.6 12.779 12.779 0 1 1-9.982 23.5v-6.044l8.082-8.082a1.78 1.78 0 0 0-2.518-2.518l-5.564 5.565v-17.002a1.78 1.78 0 0 0-3.561 0v8.461l-1.473-1.473a1.781 1.781 0 1 0-2.518 2.518l3.991 3.991v14.59a12.8 12.8 0 0 1-5.223 1.234v3.563a16.387 16.387 0 0 0 5.223-.945v8.693a9.729 9.729 0 0 0-5.223-3v3.689a6.172 6.172 0 0 1 3.859 3.9 1.781 1.781 0 0 0 2.561.994 3.722 3.722 0 0 1 5.1 5h-11.521v3.561h12.453a1.781 1.781 0 0 0 1.365-.637 7.282 7.282 0 0 0-5.035-11.936V159.03a16.386 16.386 0 0 0 5.499.951z",
    transform: "translate(-265.136 -59.882)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_1889",
    d: "M0 0H72V135H0z",
    className: "cls-5",
    transform: "translate(906.405 200.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_1890",
    d: "M0 0H53V79H0z",
    className: "cls-5",
    transform: "translate(976.405 256.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_1888",
    d: "M0 0H28V16H0z",
    className: "cls-6",
    transform: "translate(987.405 319.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_1887",
    d: "M0 0H28V16H0z",
    className: "cls-6",
    transform: "translate(928.405 319.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_1885",
    d: "M0 0H71V9H0z",
    className: "cls-7",
    transform: "translate(907.405 191.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_1886",
    d: "M0 0H56V9H0z",
    className: "cls-7",
    transform: "translate(974.405 247.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1026",
    d: "M989.388 246.77V191h-72.055v144.071",
    className: "cls-8",
    transform: "translate(-10.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1027",
    d: "M995.1 303.3V215h-55.77v88.3",
    className: "cls-8",
    transform: "translate(34.417 31.77)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Repeti\\xE7\\xE3o_de_grade_5",
    clipPath: "url(#clip-path)",
    transform: "translate(918.905 209.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2343",
    transform: "translate(-961.905 -207.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_50",
    d: "M0 0L0 4",
    className: "cls-8",
    transform: "translate(964.405 210.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_53",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(964.405 228.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_56",
    d: "M0 0L0 4",
    className: "cls-8",
    transform: "translate(964.405 247.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_59",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(964.405 265.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_62",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(964.405 284.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_65",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(964.405 302.071)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2343-2",
    transform: "translate(-947.905 -207.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_50-2",
    d: "M0 0L0 4",
    className: "cls-8",
    transform: "translate(964.405 210.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_53-2",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(964.405 228.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_56-2",
    d: "M0 0L0 4",
    className: "cls-8",
    transform: "translate(964.405 247.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_59-2",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(964.405 265.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_62-2",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(964.405 284.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_65-2",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(964.405 302.071)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2343-3",
    transform: "translate(-933.905 -207.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_50-3",
    d: "M0 0L0 4",
    className: "cls-8",
    transform: "translate(964.405 210.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_53-3",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(964.405 228.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_56-3",
    d: "M0 0L0 4",
    className: "cls-8",
    transform: "translate(964.405 247.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_59-3",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(964.405 265.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_62-3",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(964.405 284.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_65-3",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(964.405 302.071)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2343-4",
    transform: "translate(-919.905 -207.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_50-4",
    d: "M0 0L0 4",
    className: "cls-8",
    transform: "translate(964.405 210.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_53-4",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(964.405 228.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_56-4",
    d: "M0 0L0 4",
    className: "cls-8",
    transform: "translate(964.405 247.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_59-4",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(964.405 265.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_62-4",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(964.405 284.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_65-4",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(964.405 302.071)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_66",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(987.405 265.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_67",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(1001.405 265.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_68",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(1015.405 265.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_69",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(987.405 284.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_70",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(1001.405 284.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_71",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(1015.405 284.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_72",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(987.405 302.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_73",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(1001.405 302.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_74",
    d: "M0 0L0 5",
    className: "cls-8",
    transform: "translate(1015.405 302.071)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1031",
    fill: "none",
    stroke: "#053462",
    strokeLinecap: "round",
    strokeWidth: "5px",
    d: "M5 0h152.508",
    transform: "translate(895.405 335.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1029",
    d: "M923.333 262.266V246h27.885v16.266",
    className: "cls-8",
    transform: "translate(5.237 72.805)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1030",
    d: "M945.333 262.266V246h27.885v16.266",
    className: "cls-8",
    transform: "translate(42.359 72.805)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_77",
    d: "M0 0L0 16",
    className: "cls-8",
    transform: "translate(942.405 319.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_78",
    d: "M0 0L0 16",
    className: "cls-8",
    transform: "translate(1001.405 319.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_79",
    d: "M0 0L68.5 0",
    className: "cls-8",
    transform: "translate(909.905 200.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_80",
    d: "M0 0L55 0",
    className: "cls-8",
    transform: "translate(974.405 256.071)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/buildings.c74aab1403c1c742bc2985b0baa32d52.svg";
export { ForwardRef as ReactComponent };